'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MainMenu = undefined;

var _themeProvider = require('@spp/theme-provider');

var _MainMenu = require('./MainMenu');

var _MainMenu2 = _interopRequireDefault(_MainMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.MainMenu = _MainMenu2.default;
exports.default = (0, _themeProvider.themer)('@spp/cn-main-menu')(_MainMenu2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/MainMenu/index.js
 ** module id = 602
 ** module chunks = 1
 **/